document.addEventListener('DOMContentLoaded', function () {
    const carouseInner = document.querySelector('.carouse_wrap');
    const items = document.querySelectorAll('.carouse_inner');
    const toggleButton = document.getElementById('togglePlayPause');
    let itemWidth = window.innerWidth < 768 ? 240 : 440; // 根据窗口宽度动态设置 itemWidth
    const totalItems = items.length;
    const itemsPerView = Math.ceil(window.innerWidth / itemWidth); // 计算屏幕中可以看到的项目数量
    let currentTranslateX = -itemWidth * itemsPerView; // 从克隆的第一个元素开始
    let step = 2;  // 滑动步长，控制速度
    let isHovered = false; // 标记鼠标是否悬停
    let isAnimating = false;
    let offsetCorrected = false;
    let animationId; // 用来存储 requestAnimationFrame 的 ID
    let isPaused = false; // 新增变量，控制播放和暂停
  
    // 克隆最后 itemsPerView 个元素到开头
    for (let i = totalItems - itemsPerView; i < totalItems; i++) {
      const clone = items[i].cloneNode(true);
      carouseInner.insertBefore(clone, carouseInner.firstChild);
    }
  
    // 克隆前 itemsPerView 个元素到末尾
    for (let i = 0; i < itemsPerView; i++) {
      const clone = items[i].cloneNode(true);
      carouseInner.appendChild(clone);
    }
  
    // 设置初始位置（从克隆的第一个元素开始）
    carouseInner.style.transform = `translateX(${currentTranslateX}px)`;
  
    function slideCarousel() {
      if (!isAnimating) {
        currentTranslateX -= step;
        carouseInner.style.transform = `translateX(${currentTranslateX}px)`;
      }
  
      // 如果滑动到最右侧的克隆元素，立即跳回到真实内容的最后一个元素
      if (currentTranslateX >= 0 && !offsetCorrected) {
        isAnimating = true;
        carouseInner.style.transition = 'none'; // 取消过渡效果
        currentTranslateX = -(totalItems * itemWidth); // 重置到最后一个真实的元素
        carouseInner.style.transform = `translateX(${currentTranslateX}px)`;
  
        setTimeout(() => {
          isAnimating = false;
          carouseInner.style.transition = 'transform 0.3s linear'; // 恢复平滑过渡
        }, 20);
      }
  
      // 如果滑动到最左侧的克隆元素，立即跳回到第一个真实元素
      if (Math.abs(currentTranslateX) >= (totalItems + itemsPerView) * itemWidth && !offsetCorrected) {
        isAnimating = true;
        carouseInner.style.transition = 'none'; // 取消过渡效果
        currentTranslateX = -itemWidth * itemsPerView; // 重置到第一个真实的元素
        carouseInner.style.transform = `translateX(${currentTranslateX}px)`;
  
        setTimeout(() => {
          isAnimating = false;
          carouseInner.style.transition = 'transform 0.3s linear'; // 恢复平滑过渡
        }, 20);
      }
  
      // 修正 offsetCorrected 标志，防止重复的边界修正
      if (currentTranslateX < 0 || Math.abs(currentTranslateX) < (totalItems + itemsPerView) * itemWidth) {
        offsetCorrected = false;
      }
  
      animationId = requestAnimationFrame(slideCarousel);
    }

    // 设置 hover 时的效果
      carouseInner.addEventListener('mouseenter', function () {
        if (!isPaused) {
          isHovered = true; // 设置为悬停状态
          step = 0.5; // 当鼠标悬停时，减慢速度
        }
          
      });
  
      carouseInner.addEventListener('mouseleave', function () {
        if (!isPaused) {
          isHovered = false; // 取消悬停状态
          step = 1.7; // 恢复原来的滚动速度
        }
      });
     
      //设置 click时的效果
      toggleButton.addEventListener('click', function () {
        isPaused = !isPaused; // 切换播放状态
        toggleButton.classList.toggle('pause', isPaused); // 根据状态切换播放样式
        toggleButton.classList.toggle('play', !isPaused); // 根据状态切换暂停样式
        step = isPaused ? 0 : 1.7; // 控制动画步长
    });

  
    // 启动滑动
    slideCarousel();
  
    // 处理窗口大小调整
    function handleResize() {
      itemWidth = window.innerWidth < 768 ? 240 : 440; // 动态调整 itemWidth
      currentTranslateX = -itemWidth * itemsPerView; // 重新计算当前的 translateX
      carouseInner.style.transform = `translateX(${currentTranslateX}px)`; // 更新 translateX
    }
  
    window.addEventListener('resize', handleResize);
  
    // 页面不可见时停止动画，节省资源
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        cancelAnimationFrame(animationId); // 页面不可见时停止动画
      } else {
        slideCarousel(); // 页面可见时恢复动画
      }
    });
  
    // 页面卸载时清除事件监听器和动画
    window.addEventListener('beforeunload', function() {
      cancelAnimationFrame(animationId); // 取消动画
      window.removeEventListener('resize', handleResize); // 移除 resize 监听器
      carouseInner.removeEventListener('mouseenter', function () {}); // 清除 hover 监听器
      carouseInner.removeEventListener('mouseleave', function () {}); // 清除 hover 监听器
    });
  });